import api from './api';

const requestTokenSshd = encodedData =>
  api.post('/projects/login', null, {
    headers: {
      Authorization: `Basic ${encodedData}`,
    },
  });

// const requestTokenCnpj = encodedData =>
//   api.post('/projects/loginPublic', null, {
//     headers: {
//       Authorization: `Basic ${encodedData}`,
//     },
//   });

const registerToken = data => {
  if (data && data.token) {
    sessionStorage.setItem('Orcamento:token', JSON.stringify(data.token));
  }
};

export const grantAuthSshd = async sshdUser => {
  const flatData = `${sshdUser.sshd}:${sshdUser.password}`;
  const encodedData = btoa(flatData);

  const response = await requestTokenSshd(encodedData);

  registerToken(response.data);

  return response.data ? response.data.token : null;
};

export function parseJwt (token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
      return `%${  (`00${  c.charCodeAt(0).toString(16)}`).slice(-2)}`;
  }).join(''));

  return JSON.parse(jsonPayload);
};

// export const grantAuthCnpj = async cnpjUser => {
//   const flatData = `${cnpjUser.cnpj}:${cnpjUser.password}`;
//   const encodedData = btoa(flatData);

//   const response = await requestTokenCnpj(encodedData);

//   registerToken(response.data);

//   return response.data ? response.data.token : null;
// };

export const revokeAuth = () => {
  sessionStorage.removeItem('Orcamento:token');
};
